function copy(obj){
    var newObj = "";
    if(typeof obj=="object"){
        newObj = JSON.stringify(obj);
        return JSON.parse(newObj);
    }else{
        return newObj;
    }
}


export default {
	copy
}